import React from "react";
import { useFormContext } from "react-hook-form";
import { IParcelaGeradaNovoFluxo } from "../../../../../../Interfaces/Cobranca/Renegociacao/RenegociacaoInterfaces";
import { formatMoneyReais } from "../../../../../../Tools/FormatTools";
import { comparaDatasDia } from "../../../../../../Validations/DateValidation";

interface IParcelaModeloProps {
    parcela: IParcelaGeradaNovoFluxo;
    FL_ACORDO_ALTERAR_DATA_VENCIMENTO_FUTURA: boolean;
}

const amortText = ["0 - Gradiente", "1 - Price", "2 - SAC", "3 - Simples"];

export default function ParcelaModelo(props: IParcelaModeloProps) {
    const { register, formState } = useFormContext();

    return (
        <div className="p-5">
            <div className="row">
                <h6 className="col-12">
                    {props.parcela.Tipo_pg} - {props.parcela.NumParc_pg}
                </h6>
                <div className="w-100 d-flex flex-wrap justify-content-evenly align-items-center">
                    <span className="text-center align-middle p-2">
                        <div className="font-weight-bold text-muted mb-1">
                            Correção
                        </div>
                        <div className="font-size-lg font-weight-bolder text-dark-75">
                            {props.parcela.IdxReaj_pg}
                        </div>
                    </span>
                    <span className="text-center align-middle p-2">
                        <div className="font-weight-bold text-muted mb-1">
                            Amortização
                        </div>
                        <div className="font-size-lg font-weight-bolder text-dark-75">
                            {amortText[props.parcela.AmortParc_pg]}
                        </div>
                    </span>
                    <span className="text-center align-middle p-2">
                        <div className="font-weight-bold text-muted mb-1">
                            Valor Principal
                        </div>
                        <div className="font-size-lg font-weight-bolder text-dark-75">
                            {formatMoneyReais(props.parcela.Valor_pg)}
                        </div>
                    </span>
                    <span className="text-center align-middle p-2">
                        <div className="font-weight-bold text-muted mb-1">
                            Valor Reajustado
                        </div>
                        <div className="font-size-lg font-weight-bolder text-dark-75">
                            {formatMoneyReais(props.parcela.ValReaj_pg)}
                        </div>
                    </span>
                    <span className="text-center align-middle p-2">
                        <div className="font-weight-bold text-muted mb-1">
                            Data de Vencimento
                        </div>
                        <input
                            type="date"
                            name={`parcelas.${props.parcela.Tipo_pg}${props.parcela.NumParc_pg}.dataVencimento`}
                            ref={register({
                                validate: (date) =>
                                    comparaDatasDia(
                                        new Date(`${date}T23:59Z`),
                                        new Date()
                                    )
                                        ? true
                                        : "Data Retroativa!",
                            })}
                            className={`form-control ${
                                formState.errors.parcelas?.[
                                    `${props.parcela.Tipo_pg}${props.parcela.NumParc_pg}`
                                ]?.dataVencimento
                                    ? " is-invalid"
                                    : ""
                            }`}
                            disabled={
                                !props.FL_ACORDO_ALTERAR_DATA_VENCIMENTO_FUTURA
                            }
                            defaultValue={props.parcela.Data_pg?.substr(0, 10)}
                        />
                        <div className="invalid-feedback">
                            {
                                formState.errors.parcelas?.[
                                    `${props.parcela.Tipo_pg}${props.parcela.NumParc_pg}`
                                ]?.dataVencimento?.message
                            }
                        </div>
                    </span>
                </div>
            </div>
        </div>
    );
}
